import { create } from 'zustand';
import type { Process, ArbitrationPipeline, ArbitrationStage } from '@/shared/types/database.types';

interface ArbitrationState {
  selectedProcess: Process | null;
  selectedPipeline: ArbitrationPipeline | null;
  stages: ArbitrationStage[];

  setSelectedProcess: (process: Process | null) => void;
  setSelectedPipeline: (pipeline: ArbitrationPipeline | null) => void;
  setStages: (stages: ArbitrationStage[]) => void;
  clearForOrgSwitch: () => void;
}

export const useArbitrationStore = create<ArbitrationState>((set) => ({
  selectedProcess: null,
  selectedPipeline: null,
  stages: [],

  setSelectedProcess: (process) => set({ selectedProcess: process }),
  setSelectedPipeline: (pipeline) => set({ selectedPipeline: pipeline }),
  setStages: (stages) => set({ stages }),
  clearForOrgSwitch: () => set({ selectedProcess: null, selectedPipeline: null, stages: [] }),
}));
